import { render, staticRenderFns } from "./ActivityMessage.vue?vue&type=template&id=b09220b8&scoped=true"
import script from "./ActivityMessage.vue?vue&type=script&lang=ts"
export * from "./ActivityMessage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityMessage.vue?vue&type=style&index=0&id=b09220b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09220b8",
  null
  
)

export default component.exports